import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Shield } from 'lucide-react';
export function NoGuarantee() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-24 md:py-32 px-4 sm:px-6 bg-gradient-to-b from-black via-stone-950 to-black" data-id="element-3435">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 50
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-3436">
        <div className="flex items-center justify-center gap-4 mb-8" data-id="element-3437">
          <motion.div className="w-24 h-px bg-gradient-to-r from-transparent via-yellow-500/50 to-yellow-500/50" animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} style={{
          backgroundSize: '200% 100%'
        }} data-id="element-3438" />
          <motion.div animate={{
          rotate: [0, 360],
          scale: [1, 1.15, 1]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-3439">
            <Shield className="w-10 h-10 text-yellow-400" style={{
            filter: 'drop-shadow(0 0 20px rgba(250, 204, 21, 0.8))'
          }} data-id="element-3440" />
          </motion.div>
          <motion.div className="w-24 h-px bg-gradient-to-l from-transparent via-yellow-500/50 to-yellow-500/50" animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} style={{
          backgroundSize: '200% 100%'
        }} data-id="element-3441" />
        </div>

        <motion.h2 className="text-2xl sm:text-4xl md:text-5xl font-serif mb-8 sm:mb-12 text-center" style={{
        fontFamily: 'Cinzel, serif'
      }} animate={{
        textShadow: ['0 0 40px rgba(250, 204, 21, 0.6)', '0 0 60px rgba(250, 204, 21, 0.9)', '0 0 40px rgba(250, 204, 21, 0.6)']
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-3442">
          <span className="bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 bg-clip-text text-transparent" style={{
          backgroundSize: '200% 100%',
          filter: 'drop-shadow(0 0 30px rgba(250, 204, 21, 0.8))'
        }} data-id="element-3443">
            The Guarantee
          </span>
        </motion.h2>

        <div className="space-y-6 text-lg leading-relaxed" data-id="element-3444">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={inView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative p-4 sm:p-6 md:p-10 border-4 border-yellow-500 bg-gradient-to-br from-yellow-950/40 via-yellow-900/30 to-black overflow-hidden" style={{
          boxShadow: '0 0 60px rgba(250, 204, 21, 0.4), inset 0 0 60px rgba(250, 204, 21, 0.1)'
        }} data-id="element-3445">
            <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-400/20 to-transparent" animate={{
            x: ['-100%', '200%']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-3446" />

            <div className="absolute top-0 left-0 w-12 h-12 border-l-4 border-t-4 border-yellow-300" data-id="element-3447" />
            <div className="absolute top-0 right-0 w-12 h-12 border-r-4 border-t-4 border-yellow-300" data-id="element-3448" />
            <div className="absolute bottom-0 left-0 w-12 h-12 border-l-4 border-b-4 border-yellow-300" data-id="element-3449" />
            <div className="absolute bottom-0 right-0 w-12 h-12 border-r-4 border-b-4 border-yellow-300" data-id="element-3450" />

            <div className="relative" data-id="element-3451">
              <p className="text-xl sm:text-2xl md:text-3xl text-center font-bold text-yellow-100 mb-4" style={{
              textShadow: '0 0 30px rgba(253, 224, 71, 0.6)'
            }} data-id="element-3452">
                Once you're in, you're in.
              </p>
              <p className="text-lg sm:text-xl md:text-2xl text-center text-yellow-200 font-semibold" data-id="element-3453">
                We don't offer refunds.
              </p>
            </div>
          </motion.div>

          <p className="text-2xl text-yellow-300 font-bold text-center" style={{
          textShadow: '0 0 20px rgba(253, 224, 71, 0.4)'
        }} data-id="element-3454">
            Here's why:
          </p>

          <div className="space-y-4 text-stone-300" data-id="element-3455">
            <p data-id="element-3456">
              If you need a guarantee to feel safe investing, you're not ready
              for this.
            </p>

            <p data-id="element-3457">
              This is for people who already know the value Brenden and Ali
              bring.
            </p>

            <p data-id="element-3458">
              Who've read Peptide Salvation and understand the depth of their
              knowledge.
            </p>

            <p data-id="element-3459">Who've seen the testimonials of "impossible" transformations.</p>

            <p data-id="element-3460">
              Who understand that access to this level of expertise is worth
              exponentially more than the investment.
            </p>

            <p data-id="element-3461">
              Who are committed to their own transformation, not looking for an
              escape hatch.
            </p>
          </div>

          <motion.p initial={{
          opacity: 0,
          x: -20
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="text-xl text-yellow-200 font-bold" style={{
          textShadow: '0 0 20px rgba(253, 224, 71, 0.4)'
        }} data-id="element-3462">
            We've found the only people who request refunds are people who
            shouldn't have bought in the first place.
          </motion.p>

          <div className="space-y-3 text-stone-300 ml-6" data-id="element-3463">
            <p data-id="element-3464">They weren't ready.</p>
            <p data-id="element-3465">They didn't actually value the expertise.</p>
            <p data-id="element-3466">
              They were looking for a magic pill instead of systematic
              optimization.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="relative p-4 sm:p-6 md:p-8 border-l-4 border-yellow-500 bg-gradient-to-br from-yellow-950/30 to-black my-6 sm:my-8" style={{
          boxShadow: '0 0 30px rgba(250, 204, 21, 0.2)'
        }} data-id="element-3467">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-yellow-400 via-yellow-500 to-transparent" data-id="element-3468" />

            <p className="text-lg sm:text-xl md:text-2xl text-yellow-200 font-bold mb-4 sm:mb-6" style={{
            textShadow: '0 0 20px rgba(253, 224, 71, 0.4)'
          }} data-id="element-3469">
              Our commitment is to deliver world-class intelligence.
            </p>

            <div className="space-y-4 text-stone-300" data-id="element-3470">
              <p className="flex items-start gap-3" data-id="element-3471">
                <span className="text-yellow-400 text-xl mt-0.5" data-id="element-3472">•</span>
                <span data-id="element-3473">
                  To give you live sessions with two of the most advanced
                  biological optimization experts in the world.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-3474">
                <span className="text-yellow-400 text-xl mt-0.5" data-id="element-3475">•</span>
                <span data-id="element-3476">
                  To provide you with the most comprehensive peptide training
                  ever created.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-3477">
                <span className="text-yellow-400 text-xl mt-0.5" data-id="element-3478">•</span>
                <span data-id="element-3479">
                  To share exclusive bonuses, case studies, and reports that
                  save you thousands in wasted purchases.
                </span>
              </p>
            </div>
          </motion.div>

          <p className="text-lg sm:text-xl md:text-2xl text-yellow-200 font-bold" style={{
          textShadow: '0 0 20px rgba(253, 224, 71, 0.4)'
        }} data-id="element-3480">
            Your commitment is to show up, absorb, and apply it.
          </p>

          <div className="space-y-3 text-stone-300 ml-6" data-id="element-3481">
            <p className="flex items-start gap-3" data-id="element-3482">
              <span className="text-yellow-400 text-xl mt-0.5" data-id="element-3483">•</span>
              <span data-id="element-3484">To ask questions during the live sessions.</span>
            </p>
            <p className="flex items-start gap-3" data-id="element-3485">
              <span className="text-yellow-400 text-xl mt-0.5" data-id="element-3486">•</span>
              <span data-id="element-3487">To implement the protocols.</span>
            </p>
            <p className="flex items-start gap-3" data-id="element-3488">
              <span className="text-yellow-400 text-xl mt-0.5" data-id="element-3489">•</span>
              <span data-id="element-3490">To optimize based on your results.</span>
            </p>
          </div>

          <motion.div className="h-1 bg-gradient-to-r from-yellow-500 via-yellow-300 to-yellow-500 my-10" animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} style={{
          backgroundSize: '200% 100%',
          boxShadow: '0 0 20px rgba(250, 204, 21, 0.6)'
        }} data-id="element-3491" />

          <p className="text-lg sm:text-xl md:text-2xl text-stone-100 font-bold text-center" data-id="element-3492">
            If you don't want to commit to this…
          </p>

          <p className="text-xl text-stone-300 text-center" data-id="element-3493">That's okay.</p>

          <p className="text-xl text-stone-300 text-center" data-id="element-3494">
            This isn't for everyone.
          </p>

          <motion.p className="text-xl sm:text-2xl md:text-3xl font-bold text-center" style={{
          fontFamily: 'Cinzel, serif'
        }} animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-3495"></motion.p>
        </div>
      </motion.div>
    </section>;
}